import React from 'react';
import { StepProps } from '../../types/onboarding';
import { FileText, BarChart, Calendar, DollarSign } from 'lucide-react';
import { Button } from '../ui/button';

export const TourStep: React.FC<StepProps> = ({ onNext }) => {

  const tourHighlights = [
    {
      icon: <FileText className="w-8 h-8" />,
      title: 'Create Work Orders',
      description: 'Track maintenance requests, repairs, and projects',
    },
    {
      icon: <BarChart className="w-8 h-8" />,
      title: 'View Reports',
      description: 'Analyze trends and performance metrics',
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      title: 'Schedule Work',
      description: 'Use the calendar to plan and assign tasks',
    },
    {
      icon: <DollarSign className="w-8 h-8" />,
      title: 'Manage Invoices',
      description: 'Create invoices and track payments',
    },
  ];

  const handleComplete = () => {
    // Just call onNext - the wizard will handle completing onboarding
    onNext();
  };

  return (
    <div className="text-center py-8">
      <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">
        You're All Set! 🚀
      </h2>
      <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
        Here are some key features to get you started:
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        {tourHighlights.map((highlight, index) => (
          <div
            key={index}
            className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6"
          >
            <div className="text-blue-500 mb-3 flex justify-center">{highlight.icon}</div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
              {highlight.title}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">{highlight.description}</p>
          </div>
        ))}
      </div>

      <Button onClick={handleComplete} size="lg" className="px-8">
        Start Working →
      </Button>
    </div>
  );
};

